// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Caml_obj = require("rescript/lib/js/caml_obj.js");
var Js_promise = require("rescript/lib/js/js_promise.js");
var Json_decode = require("@glennsl/bs-json/src/Json_decode.res.js");
var Json_encode = require("@glennsl/bs-json/src/Json_encode.res.js");
var JsxRuntime = require("react/jsx-runtime");
var Http$ReactHooksTemplate = require("../common/http.res.js");
var Image$ReactHooksTemplate = require("../common/image.res.js");
var Campaign$ReactHooksTemplate = require("./campaign.res.js");
var ToggleInput$ReactHooksTemplate = require("../common/ToggleInput.res.js");
var CampaignMode$ReactHooksTemplate = require("../general_settings/CampaignMode.res.js");
var AlertComponent$ReactHooksTemplate = require("../common/AlertComponent.res.js");
var GenerateTickets$ReactHooksTemplate = require("../general_settings/GenerateTickets.res.js");
var ImportEnrichments$ReactHooksTemplate = require("../general_settings/ImportEnrichments.res.js");
var ApplicationSetting$ReactHooksTemplate = require("../general_settings/applicationSetting.res.js");
var SavePartialResponses$ReactHooksTemplate = require("../general_settings/SavePartialResponses.res.js");
var SurveyResponseWindows$ReactHooksTemplate = require("../general_settings/SurveyResponseWindows.res.js");
var TicketAutoAssignments$ReactHooksTemplate = require("../general_settings/TicketAutoAssignments.res.js");
var ConfigurationSettingCard$ReactHooksTemplate = require("../common/ConfigurationSettingCard.res.js");

var unsavedChangesMessage = "You have unsaved changes. Are you sure you want to leave without saving?";

function CampaignConfiguration(props) {
  var onEditedChange = props.onEditedChange;
  var onUpdate = props.onUpdate;
  var onClose = props.onClose;
  var initialState_campaign = props.campaign;
  var initialState = {
    campaign: initialState_campaign,
    notification: undefined,
    edited: false
  };
  var match = React.useState(function (param) {
        return initialState;
      });
  var setState = match[1];
  var state = match[0];
  var match$1 = React.useState(function (param) {
        
      });
  var setCopiedField = match$1[1];
  var copiedField = match$1[0];
  var notifyEdited = function (edited) {
    if (onEditedChange !== undefined) {
      return Curry._1(onEditedChange, edited);
    }
    
  };
  var requestClose = function (param) {
    if (!state.edited) {
      return Curry._1(onClose, undefined);
    }
    var confirmed = window.confirm(unsavedChangesMessage);
    if (confirmed) {
      notifyEdited(false);
      return Curry._1(onClose, undefined);
    }
    
  };
  var uidCopyBlock = function (value, fieldKey) {
    var isCopied = Caml_obj.equal(copiedField, fieldKey);
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsxs("div", {
                        children: [
                          JsxRuntime.jsx("p", {
                                children: "Campaign UID",
                                className: "text-xs font-semibold text-pigmentblue uppercase tracking-wide"
                              }),
                          JsxRuntime.jsx("p", {
                                children: value === "" ? "—" : value,
                                className: "text-sm font-mono font-semibold text-darkcharcoal truncate mt-1",
                                title: value
                              })
                        ],
                        className: "min-w-0 flex-1"
                      }),
                  JsxRuntime.jsx("button", {
                        children: isCopied ? JsxRuntime.jsx("span", {
                                children: "Copied",
                                className: "text-xs font-semibold"
                              }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
                                children: [
                                  JsxRuntime.jsx("img", {
                                        className: "h-4 w-4",
                                        src: Image$ReactHooksTemplate.copy
                                      }),
                                  JsxRuntime.jsx("span", {
                                        children: "Copy",
                                        className: "text-xs font-semibold"
                                      })
                                ]
                              }),
                        "aria-label": "Copy Campaign UID",
                        className: "flex-shrink-0 inline-flex items-center gap-1.5 px-2.5 py-1.5 rounded-md border border-lavenderweb bg-white text-pigmentblue hover:bg-lavenderweb transition-colors duration-200",
                        title: "Copy Campaign UID",
                        type: "button",
                        onClick: (function (param) {
                            Js_promise.then_((function (param) {
                                    Curry._1(setCopiedField, (function (param) {
                                            return fieldKey;
                                          }));
                                    setTimeout((function (param) {
                                            Curry._1(setCopiedField, (function (param) {
                                                    
                                                  }));
                                          }), 2000);
                                    return Promise.resolve();
                                  }), navigator.clipboard.writeText(value));
                          })
                      })
                ],
                className: "group relative rounded-xl border border-lavenderweb bg-ghostwhiteblue flex items-center justify-between gap-3 px-3 py-2.5 " + ConfigurationSettingCard$ReactHooksTemplate.hoverAnimation(true)
              });
  };
  React.useEffect((function (param) {
          var handler = function ($$event) {
            var key = $$event.key;
            if (key === "Escape") {
              return requestClose();
            }
            
          };
          document.addEventListener("keydown", handler);
          return (function (param) {
                    document.removeEventListener("keydown", handler);
                  });
        }), [state.edited]);
  React.useEffect((function (param) {
          if (!state.edited) {
            return ;
          }
          var handler = (function (event) {
          event.preventDefault();
          event.returnValue = '';
        });
          window.addEventListener("beforeunload", handler);
          return (function (param) {
                    window.removeEventListener("beforeunload", handler);
                  });
        }), [state.edited]);
  var onChange = function (id, setting, enforce) {
    var newApplicationSettings = List.map((function (x) {
            if (ApplicationSetting$ReactHooksTemplate.id(x) === id && !ApplicationSetting$ReactHooksTemplate.enforced(x)) {
              return ApplicationSetting$ReactHooksTemplate.setEnforce(enforce, ApplicationSetting$ReactHooksTemplate.setIndividualSetting(setting, x));
            } else {
              return x;
            }
          }), Campaign$ReactHooksTemplate.applicationSettings(state.campaign));
    Curry._1(setState, (function (state) {
            return {
                    campaign: Campaign$ReactHooksTemplate.setApplicationSettings(state.campaign, newApplicationSettings),
                    notification: state.notification,
                    edited: true
                  };
          }));
    notifyEdited(true);
  };
  var toggleVerificationCode = function (param) {
    var currentValue = Campaign$ReactHooksTemplate.surveyVerificationCode(state.campaign);
    var updatedCampaign = Campaign$ReactHooksTemplate.setSurveyVerificationCode(state.campaign, !currentValue);
    Curry._1(setState, (function (prevState) {
            return {
                    campaign: updatedCampaign,
                    notification: prevState.notification,
                    edited: true
                  };
          }));
    notifyEdited(true);
  };
  var updateCampaignSettings = function (e) {
    e.preventDefault();
    var campaignId = Campaign$ReactHooksTemplate.id(state.campaign);
    var params = {};
    params["campaign"] = Json_encode.object_({
          hd: [
            "system_settings_attributes",
            Json_encode.list(ApplicationSetting$ReactHooksTemplate.encode, Campaign$ReactHooksTemplate.applicationSettings(state.campaign))
          ],
          tl: {
            hd: [
              "survey_verification_code",
              Campaign$ReactHooksTemplate.surveyVerificationCode(state.campaign)
            ],
            tl: /* [] */0
          }
        });
    Js_promise.then_((function (response) {
            var status = Json_decode.field("status", (function (param) {
                    return Json_decode.withDefault("error", Json_decode.string, param);
                  }), response);
            var tmp;
            switch (status) {
              case "error" :
                  var errorMessage = Json_decode.field("error", Json_decode.string, response);
                  tmp = Curry._1(setState, (function (state) {
                          return {
                                  campaign: state.campaign,
                                  notification: {
                                    TAG: "Failure",
                                    _0: errorMessage
                                  },
                                  edited: state.edited
                                };
                        }));
                  break;
              case "failure" :
                  tmp = Curry._1(setState, (function (state) {
                          return {
                                  campaign: state.campaign,
                                  notification: {
                                    TAG: "Failure",
                                    _0: "Invalid settings"
                                  },
                                  edited: state.edited
                                };
                        }));
                  break;
              case "success" :
                  var campaign = Json_decode.field("campaign", Campaign$ReactHooksTemplate.decode, response);
                  Curry._1(setState, (function (param) {
                          return {
                                  campaign: campaign,
                                  notification: {
                                    TAG: "Success",
                                    _0: "Settings Updated"
                                  },
                                  edited: false
                                };
                        }));
                  notifyEdited(false);
                  tmp = Curry._1(onUpdate, campaign);
                  break;
              default:
                tmp = Curry._1(setState, (function (state) {
                        return {
                                campaign: state.campaign,
                                notification: {
                                  TAG: "Failure",
                                  _0: "Something went wrong. Please try again later"
                                },
                                edited: state.edited
                              };
                      }));
            }
            return Js_promise.$$catch((function (err) {
                          return Promise.resolve((console.log(err), Curry._1(setState, (function (state) {
                                              return {
                                                      campaign: state.campaign,
                                                      notification: {
                                                        TAG: "Failure",
                                                        _0: "Something went wrong. Please contact admin"
                                                      },
                                                      edited: state.edited
                                                    };
                                            }))));
                        }), Promise.resolve(tmp));
          }), Http$ReactHooksTemplate.fetchPostJSON("/api/v1/campaigns/" + String(campaignId) + "/update", params));
  };
  var verificationEnabled = Campaign$ReactHooksTemplate.surveyVerificationCode(state.campaign);
  var sectionHeader = function (title, icon) {
    return JsxRuntime.jsxs("div", {
                children: [
                  JsxRuntime.jsx("img", {
                        className: "w-4 h-4 opacity-70",
                        src: icon
                      }),
                  title
                ],
                className: "flex items-center gap-2 rounded-lg bg-ghostwhiteblue border border-lavenderweb px-3 py-2.5 text-xs font-semibold text-darkcharcoal mb-3"
              });
  };
  var alertType = state.notification;
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx("div", {
                      "aria-hidden": true,
                      className: "fixed left-0 right-0 bottom-0 bg-cetaceanblue bg-opacity-20 z-40 transition-opacity duration-200",
                      style: {
                        top: "62px"
                      },
                      onMouseDown: (function (param) {
                          requestClose();
                        })
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        JsxRuntime.jsx("h2", {
                                              children: "Campaign Configuration",
                                              className: "text-sm font-semibold text-darkcharcoal truncate",
                                              id: "campaign-configuration-title"
                                            }),
                                        JsxRuntime.jsx("p", {
                                              children: "Behavior, distribution, and response settings",
                                              className: "text-xs text-aurometalsaurus mt-0.5"
                                            })
                                      ],
                                      className: "min-w-0"
                                    }),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        state.edited ? JsxRuntime.jsx("span", {
                                                children: "Unsaved changes",
                                                className: "px-2.5 py-1 text-xs font-medium text-orange-700 bg-orange-50 rounded-full border border-orange-200 whitespace-nowrap"
                                              }) : null,
                                        JsxRuntime.jsx("button", {
                                              children: state.edited ? "Save Changes" : "Saved",
                                              className: (
                                                state.edited ? "bg-pigmentblue text-white hover:bg-cetaceanblue shadow-sm" : "bg-gray-100 text-gray-400 cursor-not-allowed"
                                              ) + " inline-flex items-center px-3.5 py-2 rounded-lg text-xs font-medium transition-colors duration-200 focus:outline-none disabled:cursor-not-allowed",
                                              disabled: !state.edited,
                                              type: "button",
                                              onClick: updateCampaignSettings
                                            }),
                                        JsxRuntime.jsx("button", {
                                              children: JsxRuntime.jsx("img", {
                                                    className: "w-3 h-3",
                                                    src: Image$ReactHooksTemplate.closeIcon
                                                  }),
                                              "aria-label": "Close configuration",
                                              className: "p-2 rounded-lg hover:bg-ghostwhiteblue transition-colors duration-200 flex-shrink-0",
                                              type: "button",
                                              onClick: (function (param) {
                                                  requestClose();
                                                })
                                            })
                                      ],
                                      className: "flex items-center gap-2 flex-shrink-0"
                                    })
                              ],
                              className: "flex-shrink-0 flex items-start justify-between gap-3 px-4 py-3.5 border-b border-gray-200 bg-white"
                            }),
                        alertType !== undefined ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx("div", {
                                      children: JsxRuntime.jsx(AlertComponent$ReactHooksTemplate.make, {
                                            alertType: alertType,
                                            handleClose: (function (param) {
                                                Curry._1(setState, (function (state) {
                                                        return {
                                                                campaign: state.campaign,
                                                                notification: undefined,
                                                                edited: state.edited
                                                              };
                                                      }));
                                              })
                                          }),
                                      className: "absolute top-2 left-0 right-0"
                                    }),
                                className: "relative z-50"
                              }) : null,
                        JsxRuntime.jsxs("div", {
                              children: [
                                JsxRuntime.jsx("div", {
                                      children: uidCopyBlock(Campaign$ReactHooksTemplate.uid(state.campaign), "uid"),
                                      className: "mt-3 mb-4"
                                    }),
                                sectionHeader("Campaign Settings", Image$ReactHooksTemplate.cogTransparent),
                                JsxRuntime.jsxs("div", {
                                      children: [
                                        $$Array.of_list(List.map((function (x) {
                                                    var y = ApplicationSetting$ReactHooksTemplate.individualSetting(x);
                                                    switch (y.TAG) {
                                                      case "SavePartialResponse" :
                                                          var partial_arg = ApplicationSetting$ReactHooksTemplate.id(x);
                                                          return JsxRuntime.jsx(SavePartialResponses$ReactHooksTemplate.make, {
                                                                      setting: y._0,
                                                                      enforce: ApplicationSetting$ReactHooksTemplate.enforce(x),
                                                                      enforced: ApplicationSetting$ReactHooksTemplate.enforced(x),
                                                                      onChange: (function (param, param$1) {
                                                                          return onChange(partial_arg, param, param$1);
                                                                        }),
                                                                      compact: true
                                                                    });
                                                      case "GenerateTicket" :
                                                          var partial_arg$1 = ApplicationSetting$ReactHooksTemplate.id(x);
                                                          return JsxRuntime.jsx(GenerateTickets$ReactHooksTemplate.make, {
                                                                      setting: y._0,
                                                                      enforce: ApplicationSetting$ReactHooksTemplate.enforce(x),
                                                                      enforced: ApplicationSetting$ReactHooksTemplate.enforced(x),
                                                                      onChange: (function (param, param$1) {
                                                                          return onChange(partial_arg$1, param, param$1);
                                                                        }),
                                                                      compact: true
                                                                    });
                                                      case "CampaignModes" :
                                                          var partial_arg$2 = ApplicationSetting$ReactHooksTemplate.id(x);
                                                          return JsxRuntime.jsx(CampaignMode$ReactHooksTemplate.make, {
                                                                      setting: y._0,
                                                                      enforce: ApplicationSetting$ReactHooksTemplate.enforce(x),
                                                                      enforced: ApplicationSetting$ReactHooksTemplate.enforced(x),
                                                                      onChange: (function (param, param$1) {
                                                                          return onChange(partial_arg$2, param, param$1);
                                                                        }),
                                                                      compact: true
                                                                    });
                                                      case "SurveyResponseWindow" :
                                                          var partial_arg$3 = ApplicationSetting$ReactHooksTemplate.id(x);
                                                          return JsxRuntime.jsx(SurveyResponseWindows$ReactHooksTemplate.make, {
                                                                      setting: y._0,
                                                                      enforce: ApplicationSetting$ReactHooksTemplate.enforce(x),
                                                                      enforced: ApplicationSetting$ReactHooksTemplate.enforced(x),
                                                                      onChange: (function (param, param$1) {
                                                                          return onChange(partial_arg$3, param, param$1);
                                                                        }),
                                                                      enforceable: false,
                                                                      compact: true
                                                                    });
                                                      case "PaginationPolicies" :
                                                      case "AutoAdvance" :
                                                          return null;
                                                      case "TicketAutoAssignment" :
                                                          var partial_arg$4 = ApplicationSetting$ReactHooksTemplate.id(x);
                                                          return JsxRuntime.jsx(TicketAutoAssignments$ReactHooksTemplate.make, {
                                                                      setting: y._0,
                                                                      enforce: ApplicationSetting$ReactHooksTemplate.enforce(x),
                                                                      enforced: ApplicationSetting$ReactHooksTemplate.enforced(x),
                                                                      onChange: (function (param, param$1) {
                                                                          return onChange(partial_arg$4, param, param$1);
                                                                        }),
                                                                      enforceable: false,
                                                                      compact: true
                                                                    });
                                                      case "ImportEnrichment" :
                                                          var partial_arg$5 = ApplicationSetting$ReactHooksTemplate.id(x);
                                                          return JsxRuntime.jsx(ImportEnrichments$ReactHooksTemplate.make, {
                                                                      setting: y._0,
                                                                      enforce: ApplicationSetting$ReactHooksTemplate.enforce(x),
                                                                      enforced: ApplicationSetting$ReactHooksTemplate.enforced(x),
                                                                      onChange: (function (param, param$1) {
                                                                          return onChange(partial_arg$5, param, param$1);
                                                                        }),
                                                                      campaignScope: true,
                                                                      compact: true
                                                                    });
                                                      
                                                    }
                                                  }), Campaign$ReactHooksTemplate.applicationSettings(state.campaign))),
                                        JsxRuntime.jsx("div", {
                                              children: JsxRuntime.jsxs("div", {
                                                    children: [
                                                      JsxRuntime.jsxs("div", {
                                                            children: [
                                                              JsxRuntime.jsxs("div", {
                                                                    children: [
                                                                      JsxRuntime.jsx("h3", {
                                                                            children: "Survey Verification Code",
                                                                            className: ConfigurationSettingCard$ReactHooksTemplate.titleClass(verificationEnabled)
                                                                          }),
                                                                      JsxRuntime.jsx(ConfigurationSettingCard$ReactHooksTemplate.statusBadge, {
                                                                            enabled: verificationEnabled
                                                                          })
                                                                    ],
                                                                    className: "flex items-center gap-2 flex-wrap"
                                                                  }),
                                                              JsxRuntime.jsx("p", {
                                                                    children: "Generate a unique code on the Thank You page for each survey completion",
                                                                    className: ConfigurationSettingCard$ReactHooksTemplate.descriptionClass(verificationEnabled)
                                                                  })
                                                            ],
                                                            className: "min-w-0"
                                                          }),
                                                      JsxRuntime.jsx("div", {
                                                            children: JsxRuntime.jsx(ToggleInput$ReactHooksTemplate.make, {
                                                                  checked: verificationEnabled,
                                                                  handleChange: toggleVerificationCode,
                                                                  labelClassName: "flex items-center"
                                                                }),
                                                            className: "flex-shrink-0"
                                                          })
                                                    ],
                                                    className: "flex items-start justify-between gap-3"
                                                  }),
                                              className: ConfigurationSettingCard$ReactHooksTemplate.compactCardClass(false, verificationEnabled)
                                            })
                                      ],
                                      className: "flex flex-col gap-3"
                                    })
                              ],
                              className: "flex-1 min-h-0 overflow-y-auto overflow-x-hidden px-4 pb-8 pt-1"
                            })
                      ],
                      "aria-modal": true,
                      "aria-labelledby": "campaign-configuration-title",
                      className: "bg-white w-full sm:min-w-400-px lg:w-5/12 fixed right-0 bottom-0 z-40 border-l border-gray-200 shadow-2xl flex flex-col overflow-hidden",
                      role: "dialog",
                      style: {
                        maxWidth: "440px",
                        top: "62px"
                      },
                      onMouseDown: (function ($$event) {
                          $$event.stopPropagation();
                        })
                    })
              ]
            });
}

var make = CampaignConfiguration;

exports.unsavedChangesMessage = unsavedChangesMessage;
exports.make = make;
/* react Not a pure module */
